import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { Popover, OverlayTrigger } from "react-bootstrap";

import * as homeReducer from "containers/Home/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import RetargetOutcomeModal from "components/UnifiedProject/SelectData/RetargetOutcomeModal";

class RetargetOutcomeModalContainer extends React.Component {
  state = {
    showModal: false
  };

  render() {
    const { children, className, style, dataset } = this.props;
    const { showModal } = this.state;

    const noOutcome = dataset.status && dataset.status.indexOf("missing_target_variable") !== -1;
    const finishedIndexing =
      dataset.status &&
      dataset.status.indexOf("indexing") === -1 &&
      dataset.status.indexOf("finishing_indexing") === -1 &&
      !dataset.stack_id;
    const isError = dataset.errors && dataset.errors.length > 0;
    const isDone = dataset.rowCount !== -1 || (finishedIndexing && noOutcome);
    const isLoading = !isDone && !isError;

    if (isLoading) {
      return (
        <LoadingIndicator
          style={{
            margin: "-14px 0px 0px -12px",
            width: "48px",
            height: "32px",
            transform: "scale(0.50)"
          }}
        />
      );
    }

    return (
      <React.Fragment>
        <RetargetOutcomeModal
          {...this.props}
          showModal={showModal}
          handleShow={(value = false) => this.setState({ showModal: value })}
        />
        <OverlayTrigger
          placement="top"
          trigger={["hover"]}
          rootClose
          overlay={
            <Popover id="popover-positioned-top">
              <div>{"Change target outcome"}</div>
            </Popover>
          }
        >
          {children ? (
            <div
              className={className}
              style={style}
              onClick={() => {
                this.setState({ showModal: true });
              }}
            >
              {children}
            </div>
          ) : (
            <Button
              onClick={() => {
                this.setState({ showModal: true });
              }}
            >
              {"Change Target Outcome"}
            </Button>
          )}
        </OverlayTrigger>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const datasetId = ownProps.dataset ? ownProps.dataset.id : ownProps.id;
  return {
    handleRetarget: (val) => dispatch(homeReducer.changeDatasetTarget(datasetId, val, ownProps.runId))
  };
};

const mapStateToProps = (state, ownProps) => {
  const dataset = ownProps.dataset ? ownProps.dataset : homeReducer.getDataset(state, ownProps.id);
  return {
    dataset: dataset,
    outcomeOptions: homeReducer.getOutcomeOptions(state, dataset && dataset.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RetargetOutcomeModalContainer);
